// extracted by mini-css-extract-plugin
export default {"card1":"CardProduct_card1__73nC0"};